import { useState, useEffect } from 'react';
import { isOnClient } from '@growth/ssr-utils';

function useNetwork() {
  var navigatorOnline = isOnClient ? window.navigator.onLine : true;
  var _useState = useState(navigatorOnline),
    isOnline = _useState[0],
    setNetwork = _useState[1];
  var updateNetwork = function updateNetwork() {
    setNetwork(window.navigator.onLine);
  };
  useEffect(function () {
    window.addEventListener('offline', updateNetwork);
    window.addEventListener('online', updateNetwork);
    return function () {
      window.removeEventListener('offline', updateNetwork);
      window.removeEventListener('online', updateNetwork);
    };
  });
  return [isOnline];
}

export { useNetwork };
